module.exports = __webpack_public_path__ + "static/media/right-chevron.6770e21b.svg";